import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const SecuredCard = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 28 28"
    fill="none"
    {...props}
  >
    <Path
      d="M1.778 9.348v9.732a2.37 2.37 0 0 0 2.367 2.367h18.728a2.37 2.37 0 0 0 2.367-2.367V9.348H1.778Z"
      fill="#54A0FF"
    />
    <Path
      d="M25.24 9.348v9.732a2.37 2.37 0 0 1-2.367 2.367H13.51v-12.1H25.24Z"
      fill="#338DEF"
    />
    <Path
      d="M7.617 18.133H5.934a.79.79 0 0 1 0-1.578h1.683a.79.79 0 0 1 0 1.578ZM12.667 18.133h-1.683a.79.79 0 0 1 0-1.578h1.683a.79.79 0 1 1 0 1.578Z"
      fill="#F2F2FC"
    />
    <Path
      d="M25.24 6.296v3.052H1.778V6.296A2.37 2.37 0 0 1 4.145 3.93h18.728a2.37 2.37 0 0 1 2.367 2.367Z"
      fill="#54A0FF"
    />
    <Path
      d="M25.24 6.296v3.052H13.51V3.929h9.364a2.37 2.37 0 0 1 2.367 2.367Z"
      fill="#338DEF"
    />
    <Path
      d="M11.773 11.82H5.881a.79.79 0 0 1-.79-.789V7.664a.79.79 0 0 1 .79-.789h5.892a.79.79 0 0 1 .79.79v3.366a.79.79 0 0 1-.79.79Z"
      fill="#fff"
    />
    <Path
      d="M27.716 11.661h-.08a8.307 8.307 0 0 1-5.307-1.92.787.787 0 0 0-1.01 0 8.307 8.307 0 0 1-5.307 1.92h-.08a.79.79 0 0 0-.789.79v4.393c0 1.953.621 3.808 1.797 5.367a8.845 8.845 0 0 0 4.667 3.203.775.775 0 0 0 .434 0 8.845 8.845 0 0 0 4.667-3.203 8.845 8.845 0 0 0 1.797-5.367V12.45a.79.79 0 0 0-.789-.789Z"
      fill="#FFD262"
    />
    <Path
      d="M28.505 12.45v4.394a8.844 8.844 0 0 1-1.797 5.367 8.845 8.845 0 0 1-4.667 3.203.775.775 0 0 1-.217.03V9.557c.18 0 .359.061.505.183a8.307 8.307 0 0 0 5.307 1.921h.08a.79.79 0 0 1 .79.79Z"
      fill="#FFC839"
    />
    <Path
      d="m25.644 16.113-3.262 3.261a.786.786 0 0 1-1.116 0l-1.683-1.683a.79.79 0 0 1 1.116-1.117l1.125 1.126 2.703-2.704a.79.79 0 0 1 1.117 1.117Z"
      fill="#F2F2FC"
    />
    <Path
      d="m25.644 16.113-3.262 3.261a.787.787 0 0 1-.558.231V17.7l2.704-2.704a.79.79 0 0 1 1.116 1.117Z"
      fill="#D6D6F2"
    />
  </Svg>
)

export default SecuredCard
